import { ControlType, FetchStatus, Property } from "../../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";
import { TextBoxProperties, useTextBoxProperties } from "./TextBoxProperties";

import { DraftTextBoxComponent } from "./DraftTextBoxComponent";
import { IControlAttributes } from "../../../../../base/models";
import { InputLabel } from "../../InputLabel";
import { Registry } from "../../../../../base/register";
import { SimpleTextBox } from "./SimpleTextBox";
import { TextBoxField } from './TextBoxField';

export const TextBoxComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useTextBoxProperties(props);
    const { label, required, title } = properties || {}
    const containerClass = label ? className : ''
    const inputClass = label ? '' : className

    const getTextBox = useCallback(() => {
        const binding = bindings?.getBinding(Property.InitValue);
        switch (binding?.type) {
            case "Field":
                return <TextBoxField
                    id={control.controlId}
                    title={title}
                    name={binding.boundValue}
                    {...properties}
                    className={inputClass}
                />
            case "Const":
            case "Expression":
            default:
                return <SimpleTextBox
                    id={control.controlId}
                    title={title}
                    {...properties}
                    value={binding?.value}
                    className={inputClass}
                />
        }

        // eslint-disable-next-line
    }, [properties, bindings, control])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <InputLabel
        htmlFor={control.controlId}
        title={title}
        label={label}
        required={required}
        className={containerClass}>
        {getTextBox()}
    </InputLabel>
}

Registry.addControl({
    id: "e408dbf4-f696-4e1b-a5a8-1b41c3fe33f4",
    name: "Text Box",
    type: ControlType.TextBox,
    properties: TextBoxProperties,
    component: TextBoxComponent,
    draftComponent: DraftTextBoxComponent
})